// extracted by mini-css-extract-plugin
export default {"empty-container":"empty-container__5Zrvm","error-box":"error-box__DKO-z"};